import { Box, chakra } from "@chakra-ui/react";

export const HumanTaskLayoutWrapper = chakra(Box, {
  baseStyle: {
    height: "full",
    p: 6,
  },
});
